namespace GeniuzPOS.Inventory {
    export interface IcStockReturnOutDtRow {
        Id?: number;
        SysDocNo?: string;
        LineItemNo?: number;
        SkuCode?: string;
        ItemRemark?: string;
        Qty?: number;
        UnitCost?: number;
        UnitChange?: UnitChangeEnumFg;
        PurUnit?: string;
        PurUnitRatio?: number;
        PurUnitPrice?: number;
        CostValue?: number;
        ExpDate?: string;
        Remark?: string;
        StkQty?: number;
        GRRefFg?: string;
        GRLineId?: number;
        QtyUse?: number;
    }

    export namespace IcStockReturnOutDtRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SkuCode';
        export const localTextPrefix = 'Inventory.IcStockReturnOutDt';
        export const lookupKey = 'Inventory.IcStockReturnOutDt';

        export function getLookup(): Q.Lookup<IcStockReturnOutDtRow> {
            return Q.getLookup<IcStockReturnOutDtRow>('Inventory.IcStockReturnOutDt');
        }
        export const deletePermission = '2Inventory:รายการ:ส่งคืน:Modify';
        export const insertPermission = '2Inventory:รายการ:ส่งคืน:Modify';
        export const readPermission = '2Inventory:รายการ:ส่งคืน:View';
        export const updatePermission = '2Inventory:รายการ:ส่งคืน:Modify';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            LineItemNo = "LineItemNo",
            SkuCode = "SkuCode",
            ItemRemark = "ItemRemark",
            Qty = "Qty",
            UnitCost = "UnitCost",
            UnitChange = "UnitChange",
            PurUnit = "PurUnit",
            PurUnitRatio = "PurUnitRatio",
            PurUnitPrice = "PurUnitPrice",
            CostValue = "CostValue",
            ExpDate = "ExpDate",
            Remark = "Remark",
            StkQty = "StkQty",
            GRRefFg = "GRRefFg",
            GRLineId = "GRLineId",
            QtyUse = "QtyUse"
        }
    }
}
